import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

import { useState, useEffect, useCallback } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import styled, { css } from 'styled-components';
import { media, pxToRem } from '@yoweb/ui/styles/utils';
import { getSpace, getZIndex } from '@yoweb/ui/styles/utils/theme';
import { Container } from '@yoweb/ui/components/containers';
import { TabVertical, TabVerticalContainer, TabHorizontal, TabHorizontalContainer } from '@yoweb/ui/components/Tabs';
import { useTranslation } from '@yoweb/next-i18next';
import { HEADER_ID } from '@store/components/Header';
import { RenderOn } from '@yoweb/ui/components/RenderOn/RenderOn';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var isBrowser = true;
export var LegalPageLayout = function LegalPageLayout(_ref) {
  var children = _ref.children,
      links = _ref.links,
      isEmbedded = _ref.isEmbedded;

  var _useState = useState(0),
      navBottom = _useState[0],
      setNavBottom = _useState[1];

  var _useRouter = useRouter(),
      pathname = _useRouter.pathname;

  var _useTranslation = useTranslation('legal'),
      t = _useTranslation.t;

  var onScroll = useCallback(function () {
    var bottom = 0;

    if (isBrowser) {
      var _document$getElementB, _document$getElementB2;

      var headerBottom = (_document$getElementB = (_document$getElementB2 = document.getElementById(HEADER_ID)) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.getBoundingClientRect().bottom) !== null && _document$getElementB !== void 0 ? _document$getElementB : 0;
      bottom = headerBottom < 0 ? 0 : headerBottom;
    }

    if (bottom !== navBottom) {
      setNavBottom(function () {
        return bottom;
      });
    }
  }, [navBottom]);
  useEffect(function () {
    var updateInterval = setInterval(onScroll, 50);
    return function () {
      clearInterval(updateInterval);
    };
  }, [onScroll]);
  return /*#__PURE__*/_jsxs(LegaleseGrid, {
    withGrid: true,
    children: [/*#__PURE__*/_jsx(Menu, {
      children: /*#__PURE__*/_jsxs(MenuSticky, {
        top: navBottom,
        children: [/*#__PURE__*/_jsx(RenderOn.MobileOnly, {
          children: /*#__PURE__*/_jsxs(TabHorizontalContainer, {
            children: [/*#__PURE__*/_jsx(HorizontalSpacer, {}), links.map(function (item) {
              return /*#__PURE__*/_jsx(Link, {
                href: item.href,
                passHref: true,
                legacyBehavior: true,
                children: /*#__PURE__*/_jsx(TabHorizontal, {
                  size: "sm",
                  isActive: pathname === item.href,
                  "data-testid": "legal-mobile-tab-".concat(item.titleKey),
                  children: t(item.titleKey)
                })
              }, item.titleKey);
            })]
          })
        }), /*#__PURE__*/_jsx(RenderOn.TabletAndDesktop, {
          children: /*#__PURE__*/_jsx(TabVerticalContainer, {
            children: links.map(function (item) {
              return /*#__PURE__*/_jsx(Link, {
                href: item.href,
                passHref: true,
                legacyBehavior: true,
                children: /*#__PURE__*/_jsx(TabVertical, {
                  as: "a",
                  isActive: pathname === item.href,
                  "data-testid": "legal-desktop-tab-".concat(item.titleKey),
                  children: t(item.titleKey)
                })
              }, item.titleKey);
            })
          })
        })]
      })
    }), /*#__PURE__*/_jsx(Content, {
      $isEmbedded: isEmbedded,
      children: children
    })]
  });
};
var HorizontalSpacer = styled.div.withConfig({
  componentId: "sc-7y3u6j-0"
})(["width:", ";"], getSpace('normal1'));
var LegaleseGrid = styled(Container).withConfig({
  componentId: "sc-7y3u6j-1"
})(["&&{padding-bottom:", ";}"], getSpace('large3'));
var Menu = styled.div.withConfig({
  componentId: "sc-7y3u6j-2"
})(["grid-column:1/5;position:relative;z-index:", ";", ""], getZIndex('above'), media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    grid-column: 1/4;\n  "]))));
var MenuSticky = styled.div.attrs(function (props) {
  return {
    top: "".concat(props.top, "px")
  };
}).withConfig({
  componentId: "sc-7y3u6j-3"
})(["position:fixed;top:0;transform:translateY(", ");left:0;right:0;", " ", ""], function (_ref2) {
  var top = _ref2.top;
  return top;
}, media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    transform: none;\n    position: sticky;\n    grid-auto-flow: row;\n    top: ", ";\n  "])), getSpace('xl3')), media.lg(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    top: ", ";\n  "])), pxToRem(270)));
var Content = styled.div.withConfig({
  componentId: "sc-7y3u6j-4"
})(["grid-column:1/5;", " ", " ", ""], media.md(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    grid-column: 4/9;\n  "]))), media.lg(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    grid-column: 4/12;\n  "]))), function (_ref3) {
  var $isEmbedded = _ref3.$isEmbedded;
  return $isEmbedded ? css(["padding-top:", ";", " ", ""], getSpace('medium3'), media.md(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n            padding-top: ", ";\n          "])), getSpace('xl2')), media.lg(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n            padding-top:", ";\n          "])), getSpace('xl4'))) : css(["padding-top:", ";", " ", ""], getSpace('xl4'), media.md(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n            padding-top: ", ";\n          "])), getSpace('xl3')), media.lg(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n            padding-top: ", ";\n          "])), pxToRem(270)));
});